<template>
  <router-link :to="href" class="link">
    {{text}}
  </router-link>
</template>

<script>
  export default {
    name: "SimpleLink",
    props: ['text', 'href']
  }
</script>

<style lang="scss">
  .link {
    font-size: rem(14px);
    line-height: rem(18px);
    text-decoration: underline;
    font-weight: 500;
    display: flex;
    align-items: center;
  }
</style>